/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
	MessageToast,
	MessageToastParams
} from "@shared/schemas/message-toast";
import { BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { ConfirmModalService } from "./confirm-modal.service";

@Injectable({
	providedIn: "root"
})
export class MessageToastService implements MessageToast {
	constructor(
		private toastr: ToastrService,
		private translate: TranslateService,
		private modalService: BsModalService,
		private confirmModalService: ConfirmModalService
	) {}

	showDefaultToast({ title, message }: Partial<MessageToastParams>): void {
		this.toastr.show(message, title);
	}

	successDefaultToast({
		title,
		message,
		options
	}: Partial<MessageToastParams>): void {
		this.toastr.success(message, title, options);
	}

	errorDefaultToast({ title, message }: Partial<MessageToastParams>): void {
		this.toastr.error(message, title);
	}

	infoDefaultToast({
		title,
		message,
		options
	}: Partial<MessageToastParams>): void {
		this.toastr.info(message, title, options);
	}

	warningDefaultToast({ title, message }: Partial<MessageToastParams>): void {
		this.toastr.warning(message, title);
	}

	showTranslatedToast({ title, message }: MessageToastParams): void {
		this.translate.get([title, message]).subscribe((translations) => {
			this.showDefaultToast({
				title: translations[title] as string,
				message: translations[message] as string
			});
		});
	}

	successTranslatedToast({ title, message }: MessageToastParams): void {
		this.translate.get([title, message]).subscribe((translations) => {
			this.successDefaultToast({
				title: translations[title] as string,
				message: translations[message] as string
			});
		});
	}

	errorTranslatedToast({ title, message }: MessageToastParams): void {
		this.translate.get([title, message]).subscribe((translations) => {
			this.errorDefaultToast({
				title: translations[title] as string,
				message: translations[message] as string
			});
		});
	}

	infoTranslatedToast({ title, message, options }: MessageToastParams): void {
		this.translate.get([title, message]).subscribe((translations) => {
			this.infoDefaultToast({
				title: translations[title] as string,
				message: translations[message] as string,
				options: options as object
			});
		});
	}

	warningTranslatedToast({ title, message }: MessageToastParams): void {
		this.translate.get([title, message]).subscribe((translations) => {
			this.warningDefaultToast({
				title: translations[title] as string,
				message: translations[message] as string
			});
		});
	}

	showMessageDeleteSuccess(): void {
		this.successTranslatedToast({
			title: "",
			message: "GLOBAL.REGISTER.DELETE.SUCCESS"
		});
	}

	showMessageSaveSuccess(): void {
		this.successTranslatedToast({
			title: "",
			message: "GLOBAL.REGISTER.SAVE.SUCCESS"
		});
	}
}
